const title = 'Have Your Say';

function createOptions() {
  const width = 490;
  const height = 445;
  const top = (window.innerHeight / 2) - (height / 2);
  const left = (window.innerWidth / 2) - (width / 2);
  return `top=${top},left=${left},width=${width},height=${height},menubar=no,location=no,resizable=no,scrollbars=no,status=no`;
}

function openResults(url, title) {
  const options = createOptions();
  window.open(url, title, options);
}

function viewHandler(e) {
  e.preventDefault();
  openResults(e.target.href, title);
}

function addOnClickHandler() {
  const anchor = document.querySelector('.section-home .poll .poll-controls a');

  if(anchor !== null) {
    anchor.addEventListener('click', viewHandler, false);
  }
}

function submitHandler(e) {
  const checked = e.target.querySelectorAll('input:checked').length > 0;

  if(!checked) {
    e.preventDefault();
    alert('Please select a poll option before submitting.');
    return;
  }

  e.target.setAttribute('target', title); // Set the POST target.
  openResults('#', title); // Open the POST target. After this line the form submits.
}

function addOnSubmitHandler() {
  const form = document.querySelector('.section-home .poll .poll-form');

  if(form !== null) {
    form.addEventListener('submit', submitHandler, false);
  }
}

function setup() {
  addOnClickHandler();
  addOnSubmitHandler();
};

export default setup;